var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"cts-main-view col-12 transaction-view-container pt-2"},[_c('TransactionsViewStandard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }